'use client'

import type { ButtonProps } from 'fukku/Button/Button.types'
import { ButtonPrimary } from 'fukku/Button/Primary'
import { ButtonSecondary } from 'fukku/Button/Secondary'
import { useRouter } from 'next/navigation'

export function BackButton({
	children,
	isSecondary = false,
	...props
}: ButtonProps & { readonly isSecondary?: boolean }) {
	const { back } = useRouter()
	const CustomButton = isSecondary ? ButtonSecondary : ButtonPrimary

	return (
		<CustomButton {...props} onClick={back}>
			{children}
		</CustomButton>
	)
}
